import moment from 'moment-jalaali'


export function toEnNum($number){
    let FA = "۱۲۳۴۵۶۷۸۹۰";
    let AR = "١٢٣٤٥٦٧٨٩٠";
    let EN = "1234567890";
    if($number)
        for (let i = 0; i < $number.length; i++) {
            for (let j = 0; j < FA.length; j++){
                $number = $number.replace(FA[j],EN[j]); //FA->EN
                $number = $number.replace(AR[j],EN[j]); //AR->EN
            }
        }
    return $number;
}
export function formatDateToJalali(timestamp) {
    moment.loadPersian({usePersianDigits: true , dialect: 'persian-modern'})
    let m = moment(timestamp);
   return  Number(toEnNum(m.format('jD'))) <= 15 ?
       m.format("jMMMM") : m.add(1, 'jMonth').format('jMMMM') ;
}
export function DayOfWeek(time){
    let m = moment(time);
    let PersianDay = '';
    let dayOfWeek = m.day();
    switch(dayOfWeek){
        case 1:
            PersianDay = "دوشنبه";
            break;
        case 2:
            PersianDay = "سه شنبه";
            break;
        case 3:
            PersianDay = "چهارشنبه";
            break;
        case 4:
            PersianDay = "پنج شنبه";
            break;
        case 5:
            PersianDay = "جمعه";
            break;
        case 6:
            PersianDay = "شنبه";
            break;
        case 0:
            PersianDay = "یک شنبه";
            break;
    }
    return PersianDay
}
export function JalaliNumericDate(date){
    moment.loadPersian({usePersianDigits: true})
    let m = moment(date);
    return m.format('jYYYY/jMM/jDD');
}

export function formatDateToMiladi(date){
    moment.loadPersian({usePersianDigits: false})
    let miladiDate =  moment(date ,  'jYYYY/jM/jD');
    return miladiDate.format('YYYY-M-D');
}
export function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
}
export function formatNumberToPersian(num) {
    var finalNum = ''
    if (num === undefined || num === null) {
        return finalNum
    }
    num = num.toString()
    for (var i = 0; i < num.length; i++) {
        switch (num[i]) {
            case '1':
                finalNum += '۱'
                break;
            case '2':
                finalNum += '۲'
                break;
            case '3':
                finalNum += '۳'
                break;
            case '4':
                finalNum += '۴'
                break;
            case '5':
                finalNum += '۵'
                break;
            case '6':
                finalNum += '۶'
                break;
            case '7':
                finalNum += '۷'
                break;
            case '8':
                finalNum += '۸'
                break;
            case '9':
                finalNum += '۹'
                break;
            case '0':
                finalNum += '۰'
                break;
            default:
                finalNum += num[i]
                break;
        }
    }
    return finalNum
}
export function ToRial(str) {
    str = str.toString().replace(/[^0-9.]*/g, '');
    str = Math.round(parseFloat(str)).toString();
    let objRegex = new RegExp('(-?[0-9]+)([0-9]{3})');
    while (objRegex.test(str)) {
        str = str.replace(objRegex, '$1,$2');
    }
    return str;
}

export function AddComma( num ) {
    if(typeof num === "string"){
        let partsStr = num.split('.')
        partsStr[0] = partsStr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return partsStr.join(".");
    }
    else if (typeof num !== "string" && num !== null && num !== undefined){
        let parts = num.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }
    
    
}
export function RemoveComma(num){
    let removed = parseFloat(num.replace(/,/g, ''))
    return removed
}
export function totalCost(arr , detServ) {
    let total =  arr.filter(d => d.NationalCode === detServ.NationalCode)
        .reduce((sum , cost)  => sum + RemoveComma(cost.Itemscost), 0);
    return AddComma(total)
}
export function setCookie(c_name, value, expiredays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + value + ";path=/" + ((expiredays ==null) ? "" : ";expires=" + exdate.toGMTString());
}
export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


export function ToRialComma(str) {
    str = toEnNum(str).toString().replace(/[^0-9.]*/g, '');
    str = Math.round(parseFloat(str)).toString();
    let objRegex = new RegExp('(-?[0-9]+)([0-9]{3})');
    while (objRegex.test(str)) {
        str = str.replace(objRegex, '$1,$2');
    }
    if(str == "NaN")
        return '0';
    return str;
}
export function toNum(str){
    return toEnNum(str).toString().replace(/[^0-9.]*/g, '');
}

Object.size = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

export function melliCode_check(input) {
    if (!/^\d{10}$/.test(input))
        return false;
    
    let check = +input[9];
    let sum = Array(9).fill().map((_, i) => +input[i] * (10 - i)).reduce((x, y) => x + y) % 11;
    return (sum < 2 && check === sum) || (sum >= 2 && check + sum === 11);
}
